import { FooterComponentItem } from '@app-shared/components/footers/footer.model';
import { ClientConfig, DEFAULT_CLIENT_CONFIG } from './config.base';
import { navigationRoutes as BaseLinks, RouteParams } from './links.base';
import { DpltelematicsFooterComponent } from '@app-shared/components/footers/dpltelematics-footer/dpltelematics-footer.component';

export const CLIENT_CONFIG: ClientConfig = {
  clientName: 'dpltelematics',
  ...DEFAULT_CLIENT_CONFIG,
  logo: {
    lightLogo: 'assets/dpltelematics/light-logo.png',
    darkLogo: 'assets/dpltelematics/dark-logo.png',
    alt: 'DPL Telematics',
    width: '113px',
    height: '75px',
    loginPageWidth: '90px',
    loginPageHeight: '60px',
  },
  landingPageDetails: {
    backgroundImage: {
      src: 'assets/dpltelematics/login-page-bg.png',
    },
    headerImage: {
      src: 'assets/dpltelematics/light-logo.png',
    },
    footer: new FooterComponentItem(DpltelematicsFooterComponent),
    headerColor: '#ffffff',
  },
  showLandingPage: true,
  showCustomLoginPage: true,
};

export const navigationRoutes: RouteParams[] = CLIENT_CONFIG.allowedRoutes.map((x) => BaseLinks[x]);
